import request from '@/utils/request'

const api_prefix = '/user'

// 登录
export function login(data) {
    return request({
        url: api_prefix + '/login',
        method: 'post', // 请求方式
        data
    })
}

// 获取用户信息
export function logout() {
    return request({
        url: api_prefix + '/logout',
        method: 'post', // 请求方式
    })
}

// 获取用户信息
export function getUserInfo() {
    return request({
        url: api_prefix + '/getuserinfo',
        method: 'get', // 请求方式
    })
}

// 更新用户头像
export function updateAvatar(data) {
    return request({
        url: api_prefix + '/profile',
        method: 'post',
        data
    })
}

// 更新用户信息
export function updateUserInfo(data) {
    return request({
        url: api_prefix + '/profile',
        method: 'post',
        data
    })
}

// 修改密码
export function updatePassword(data) {
    return request({
        url: api_prefix + '/resetpwd',
        method: 'post',
        data
    })
}

// 发送验证码
export function sendSmsCode(data) {
    return request({
        url: '/sms/send',
        method: 'post',
        data
    })
}

// 获取钱包信息
export function getWalletInfo() {
    return request({
        url: api_prefix + '/wallet',
        method: 'get'
    })
}

// 获取交易列表
export function getTransactionList(params) {
    return request({
        url: api_prefix + '/wallet_transactions',
        method: 'get',
        params
    })
}

// 提现申请
export function applyWithdraw(data) {
    return request({
        url: api_prefix + '/wallet_withdraw',
        method: 'post',
        data
    })
}

// 提交教师申请
export function teacherApply(data) {
    return request({
        url: api_prefix + '/apply_teacher',
        method: 'post',
        data
    })
}

// 发布课程
export function publishCourse(data) {
    return request({
        url: api_prefix + '/publish_course',
        method: 'post',
        data
    })
}

// 发布课程章节
export function publishCourseChapter(data) {
    return request({
        url: api_prefix + '/publish_course_chapter',
        method: 'post',
        data
    })
}

// 获取我的课程列表
export function getMyCourseList(params) {
    return request({
        url: api_prefix + '/my_courses',
        method: 'get',
        params
    })
}

// 获取章节列表
export function getChapterList(params) {
    return request({
        url: api_prefix + '/course_chapters',
        method: 'get',
        params
    })
}


// 删除课程
export function deleteCourse(data) {
    return request({
        url: api_prefix + '/delete_course',
        method: 'post',
        data
    })
}

// 删除课程章节
export function deleteCourseChapter(data) {
    return request({
        url: api_prefix + '/delete_course_chapter',
        method: 'post',
        data
    })
}